import React from "react";

import withSessionHandling, {
  type SessionHandlerProps,
} from "@/context/auth/withSessionHandling";
import UserNotificationsScreen from "@/screens/Notification/UserNotificationsScreen";

function Page(props: SessionHandlerProps): React.JSX.Element {
  return <UserNotificationsScreen {...props} />;
}

export default withSessionHandling(Page);
